import {cva} from 'class-variance-authority';

const columnDivider =
  '[&:not(:last-child)]:after:absolute [&:not(:last-child)]:after:top-3 [&:not(:last-child)]:after:right-0 [&:not(:last-child)]:after:bottom-3 [&:not(:last-child)]:after:w-px [&:not(:last-child)]:after:bg-neutral-200';

const gridCellBorder =
  'border-r border-b border-neutral-200 last:border-r-0 [tbody>tr:last-child>&]:border-b-0';

export const tableVariants = cva('w-full border-separate text-sm', {
  variants: {
    variant: {
      default: 'border-spacing-y-1',
      grid: 'border-spacing-0 rounded-medium border border-neutral-200',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export const tableHeadVariants = cva(
  'relative bg-neutral-100 text-xs font-normal whitespace-nowrap text-neutral-dark',
  {
    variants: {
      variant: {
        default: [
          'px-3 py-3 first:rounded-l-medium last:rounded-r-medium',
          columnDivider,
        ],
        grid: [
          'px-2 py-1.5 first:rounded-tl-medium last:rounded-tr-medium',
          gridCellBorder,
        ],
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export const tableCellVariants = cva('relative', {
  variants: {
    variant: {
      default: [
        'bg-neutral-light px-3 py-2 first:rounded-l-medium last:rounded-r-medium',
        columnDivider,
      ],
      grid: [
        'bg-white px-2 py-1.5 [tr:last-child>&:first-child]:rounded-bl-medium [tr:last-child>&:last-child]:rounded-br-medium',
        gridCellBorder,
      ],
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});
